export interface IRecipientSearchLog {
    id: number,
    recipientReportId: number,
    actionTakenId: number,
    actionTaken: string,
    logDateTime: string,
    logDateTimeForDisplay: string,
    updateDateTime: string,
    updateDateTimeForDisplay: string,
    comments: string,
    createdByUser: number,
    createdByFullName: string,
    updatedByUser: number,
    updatedByFullName: string,
    isEditable: boolean,
    isDeletable: boolean
}